<template>
  <div>
    <PcHead></PcHead>
    <div class="p-solution">
      <p class="p-title">系统性解决方案</p>
      <img class="p-gif" src="./../../../assets/Pc/downL.gif" alt="">
      <ul class="p-content">
        <li>
          <img src="../../../assets/Pc/solute1.png" alt="">
          <div>
            <p>5G环境部署</p>
            <div>中卫佰医与中国移动集团公司政企分公司在远程医疗系统建设领域达成战略合作，双方在服务器资源、5G基础设施、云视讯技术、软件平台、硬件设备等方面全面协同，共同为医院提供集资源对接、平台建设、医联体运营为一体的远程医疗整体解决方案</div>
          </div>
        </li>
        <li>
          <div>
            <p>系统建设</p>
            <div>中卫佰医自主研发了便捷高效的远程医疗系统，实现了医院与医院、医院与医生、医生与医生之间的无缝连接，各医疗机构和各级医生上下联通，实际运行中效果良好。同时，中卫佰医与华西医院下属的华西公用医疗信息服务有限公司在互联网医院建设领域达成战略合作。</div>
          </div>
          <img src="../../../assets/Pc/solute2.png" alt="">
        </li>
        <li>
          <img src="../../../assets/Pc/solute3.png" alt="">
          <div>
            <p>医疗资源</p>
            <div>中卫佰医通过远程医疗系统构建医生协作网络，上下联通国家级大型三甲医院、省级三甲医院、地市级三甲医院、县级医院、乡镇医院、村诊所、社区服务中心、私人诊所，既有助于上级医院及医生获得优质病源、进一步提高研发水平，又有助于下级医院及医生获得精心指导，进一步提高诊疗水平，促进整体提高诊疗服务能力。</div>
          </div>
        </li>
        <li>
          <div>
            <p>专业运营</p>
            <div>中卫佰医目前在运营的省级、地市级医联体数量超过20家，月远程会诊数量超过5000例，目前以地市级核心医院组建的医联体的月远程会诊数量超过2000例，获得了相关省市领导、媒体的高度关注。</div>
          </div>
          <img src="../../../assets/Pc/solute4.png" alt="">
        </li>
        <li>
          <img src="../../../assets/Pc/solute5.png" alt="" style="transform: scale(0.9);">
          <div>
            <p>金融支持</p>
            <div> 中卫佰医在远程医疗系统和互联网医院系统的建设和运营中，均以达成促进医院发展为目标，根据医院需求，医院可以选择不进行资金投入，中卫佰医针对远程医疗系统、互联网医院系统进行建设投入，根据医院的场景及环境需求，定制符合医院要求的解决方案，并快速完成落地实施。平台建成后，中卫佰医负责运营，通过运营合作收回投资。</div>
          </div>
        </li>
      </ul>
    </div>
    <PcFooter></PcFooter>
  </div>
</template>

<script>
import PcHead from '@/components/Pc/Head.vue';
import PcFooter from '@/components/Pc/Footer.vue';
export default {
  components:{
    PcHead,
    PcFooter
  }
}
</script>

<style lang="less" scoped>
.p-solution{
  margin:0 auto;
  width:960px;
}
.p-title{
  font-size:24px;
  color:#333;
  text-align:center;
}
.p-gif {
  width: 30px;
  margin: 42px auto 30px;
  display: block;
}
.p-content{
  margin:0 auto;
  li{
    display:flex;
    margin-bottom:78px;
    img{
      margin:0 64px;
    }
    div{
      p{
        font-size:18px;
        color:#333;
        text-align:center;
        padding:22px 0 38px;
        font-family:PingFangSC-Medium;font-weight:500;
      }
      div{
        width:520px;
        font-size:16px;
        font-family:PingFangSC-Light;
        font-weight:300;
        color:rgba(51,51,51,1);
        line-height:32px;
        letter-spacing:1px;
      }
    }
  }
  li:nth-child(2){
    img{
      margin:0 0 0 106px;
    }
  }
  li:nth-child(4){
    img{
      margin:0 0 0 106px;
    }
  }
  li:nth-child(5){
    div{
      div{
        width:530px
      }
    }
  }
}
</style>